/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Spaces_Create_Provider_RequiredInputs */



/**
* | output |
* | --- |
* | "Please select a provider" |
*
* @param {Spaces_Create_Provider_RequiredInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const spaces_create_provider_required = /** @type {((inputs?: Spaces_Create_Provider_RequiredInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Spaces_Create_Provider_RequiredInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Bitte wählen Sie einen Anbieter aus")
	return /** @type {LocalizedString} */ ("Please select a provider")
});